<script>
	import { createEventDispatcher } from 'svelte';
	import { push } from 'svelte-spa-router';
	import TBox from '../templates/TBox.svelte';
	import { 
		StatusHttp, 
		TipoEvento,
		API, 
TextoFeedback} from '../../utils';

	const dispatch = createEventDispatcher();
	
	// variáveis para trabalhar com os dados do formulário
	let email, pinRecebido, dadosParse;

	let tituloAviso = "Erro";
	let feedbackUsuario = [];
	let controleEnvios = false;
	let controleEnviosTimer = null;
	let desabilitarCamposPIN = true;

	async function enviarEmail() {
		controleEnvios =  true;
		controleEnviosTimer = 60000;
		let botaoEnviarEmail = document.querySelector("#botaoEnviarEmail");
		let textoOriginalBotaoEmail = botaoEnviarEmail.innerText;

		let timerPraEnviarNovoEmail = setInterval( () => {
			controleEnviosTimer -= 1000;

			botaoEnviarEmail.innerText = `Aguarde ${controleEnviosTimer / 1000} ...`;

			if (controleEnviosTimer == 0){
				botaoEnviarEmail.innerText = textoOriginalBotaoEmail;
				clearInterval(timerPraEnviarNovoEmail);
				controleEnvios =  false;
			}
		}, 1000);

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Enviando e-mail ...'
		});
		
		const resposta = await fetch(API('pin/recuperacao'), {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				email: email,
			})
		}).catch(erros => {
			feedbackUsuario.push(TextoFeedback.ERRO_REQUISICAO);
		});

		// pega o json do retorno da resposta
		const json = await resposta.json();

		switch (resposta.status) {
			case StatusHttp.OK:
				tituloAviso = 'Tudo certo!';
				feedbackUsuario.push(json?.mensagem);
				desabilitarCamposPIN = false;
				break;
			case StatusHttp.BAD_REQUEST:
				feedbackUsuario.push(json?.mensagem);
				break;
			case StatusHttp.HTTP_NOT_FOUND:
				feedbackUsuario.push(json?.mensagem);
				break;
			case StatusHttp.TOO_MANY_REQUESTS:
				tituloAviso = 'Por favor, aguarde...';
				feedbackUsuario.push('Aguarde mais um minuto e tente novamente.');
				break;
			default:
				console.log('erro desconhecido...');
				feedbackUsuario.push('Erro desconhecido, se persistir, favor entrar em contato.');
		}
		
		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});

		// exibe feedback pro usuário se existir algo pra exibir
		if (feedbackUsuario[0]) {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: tituloAviso,
				conteudo: feedbackUsuario[0]
			});
		}

		// limpa as mensagens
		feedbackUsuario = [];
	}

	async function validarPIN() {
		localStorage.setItem('AVAL_FLAG_RESETSENHA', window.btoa(email));

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Validando PIN ...',
		});
		
		const resposta = await fetch(API('pin/validacao-senha'), {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				email: email,
				pin: pinRecebido,
			})
		}).catch(erros => {
			feedbackUsuario.push(TextoFeedback.ERRO_REQUISICAO);
		});

		// pega o json do retorno da resposta
		const json = await resposta.json();

		if (resposta.status == StatusHttp.OK) {
			tituloAviso = 'Tudo certo!';
			feedbackUsuario.push(json?.mensagem);		
			push('/acesso/senha/reset');
		} else if (resposta.status == StatusHttp.BAD_REQUEST) {
			tituloAviso = 'Erro na requisição';
			feedbackUsuario.push(json?.mensagem);
		} else {
			tituloAviso = 'Erro desconhecido';
			feedbackUsuario.push('Erro desconhecido, se persistir, favor entrar em contato.');
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});

		// exibe feedback pro usuário se existir algo pra exibir
		if (feedbackUsuario[0]) {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: tituloAviso,
				conteudo: feedbackUsuario[0]
			});
		}

		// limpa as mensagens
		feedbackUsuario = [];
	}
</script>

<style></style>

<TBox 
	titulo="Recuperação de acesso" 
	subtitulo="Leia com atenção as informações abaixo" 
	largura="8" 
	deslocamento="2" 
	correcaoY="-13px"
	icone="recuperacao">

	<p>Para recuperar seu acesso (alterar a senha) informe seu e-mail cadastrado abaixo e clique em "receber PIN".</p>

	<hr>

	<form method="post" on:submit|preventDefault={enviarEmail}>
		<div class="columns">
			<div class="column is-8">
				<div class="field">
					<input 
						bind:value={email}
						name="email" 
						type="email"
						placeholder="Digite o e-mail aqui" 
						class="input is-large is-primary has-text-weight-bold" required>
				</div>
			</div>
		
			<div class="column">
				<p class="control">
					<button 
						type="submit" 
						id="botaoEnviarEmail"
						disabled="{controleEnvios}"
						class="button is-dark is-large is-fullwidth">
						Receber PIN
					</button>
				</p>
			</div>
		</div>
	</form>

	<br>
	<p>Após recebimento do PIN, informe-o abaixo, se não recebeu, solicite outro e-mail no botão acima. <small class="has-text-primary">Verifique sua caixa de entrada, inclusive a pasta 'spam'.</small></p>
	<br>

	<form method="post" on:submit|preventDefault={validarPIN}>
		<div class="columns is-disabled">
			<div class="column is-8">
				<div class="field">
					<input 
						bind:value={pinRecebido}
						disabled="{desabilitarCamposPIN}"
						name="pin" 
						type="tel" 
						maxlength="5"
						placeholder="Digite o PIN aqui" 
						pattern="[0-9]*"
						class="input is-large is-primary has-text-weight-bold" required>
				</div>
			</div>
			<div class="column is-4">
				<p class="control">
					<button 
						disabled="{desabilitarCamposPIN}"
						type="submit" 
						class="button is-dark is-large is-fullwidth">
						Validar
					</button>
				</p>
			</div>
		</div>
	</form>

	<br>
	<br>

	<div class="has-text-centered">
		<a href="#/" class="button is-dark is-medium is-outlined">Início</a>
		<a href="#/suporte" class="button is-primary is-medium">Suporte</a>
	</div>
</TBox>